// AppFormModal.jsx
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
const { Title } = Typography;
import { useEffect } from "react";
import {
  formatSubmitValue,
  parseDefaultValue,
} from "../../../utils/helpers/formFieldUtils";

const { TextArea } = Input;

const AppFormModal = ({
  title,
  open,
  onClose,
  onValuesChange,
  fields = [],
  onSubmit,
  // form: externalForm,
  form,
  mode = "add",
}) => {
  const isViewMode = mode === "view";

  // watch all form values for conditional rendering
  const values = Form.useWatch([], form);

  // Populate form when opened
  useEffect(() => {
    if (open) {
      const values = {};
      fields.forEach((f) => {
        values[f.name] = parseDefaultValue(f, f.defaultValue);
      });
      console.log({ values });

      form.setFieldsValue(values);
    } else {
      form.resetFields();
    }
  }, [open, fields, form]);

  const handleFinish = (values) => {
    const formattedValues = {};
    fields.forEach((f) => {
      formattedValues[f.name] = formatSubmitValue(f, values[f.name]);
    });

    // onSubmit?.(formattedValues);
    // handleClose();
    onSubmit?.(formattedValues, form); // pass form too if parent needs it
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const renderField = (field) => {
    if (field.type === "empty" || field.type === "spacer") {
      return null; // don’t render Form.Item contents
    }
    if (field.type === "title" || field.type === "section") {
      return (
        <>
          {field.divider ? (
            <>
              <Divider />
              <Title style={{ color: "#008AD1" }} level={field.level || 5}>
                {field.label}
              </Title>
            </>
          ) : (
            <Title style={{ color: "#008AD1" }} level={field.level || 5}>
              {field.label}
            </Title>
          )}
        </>
      );
    }
    const commonProps = {
      disabled: isViewMode || field?.readOnly || field?.disabled,
      readOnly: isViewMode || field?.readOnly,
      placeholder: "Please enter",
    };

    switch (field.type) {
      case "date":
        return (
          <DatePicker
            format="YYYY-MM-DD"
            size="large"
            picker="date"
            disabledDate={field.disabledDate}
            {...commonProps}
          />
        );
      case "select":
        return (
          <Select
            size="large"
            showSearch
            allowClear
            placeholder="Please select"
            options={field.options?.map((v) => ({
              value: v.key,
              label: v.label,
            }))}
            {...commonProps}
          />
        );
      case "textarea":
        return (
          <TextArea autoSize={{ minRows: 3, maxRows: 5 }} {...commonProps} />
        );
      default:
        return (
          <Input
            size="large"
            type={field.type}
            {...commonProps}
            // onChange={field.onChange}
          />
        );
    }
  };

  return (
    <Drawer
      title={title}
      placement="right"
      onClose={handleClose}
      open={open}
      width={600}
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={onValuesChange}
        onFinish={handleFinish}
      >
        <Row gutter={[16, 0]}>
          {fields.map((field) => {
            // 🔑 Apply showWhen logic
            if (field.showWhen && !field.showWhen(values)) {
              return null;
            }
            return (
              <Col
                key={field.name}
                {...(field.colspan
                  ? { span: field.colspan }
                  : { xs: 24, sm: 12 })}
              >
                {field.type === "empty" ? (
                  <div style={{ height: field.height || "1rem" }} />
                ) : field.type === "title" || field.type === "section" ? (
                  renderField(field)
                ) : (
                  <Form.Item
                    label={field.label}
                    name={field.name}
                    rules={
                      field.rules?.length
                        ? field.rules
                        : field.required
                        ? [
                            {
                              required: true,
                              message:
                                field.errorMessage || "This field is required",
                            },
                          ]
                        : []
                    }
                  >
                    {renderField(field)}
                  </Form.Item>
                )}
              </Col>
            );
          })}

          <Col span={24}>
            <Form.Item>
              <Space className="w-100 justify-content-end">
                <Button
                  htmlType="button"
                  onClick={handleClose}
                  className="btn btn-danger light"
                >
                  {mode === "view" ? "Close" : "Cancel"}
                </Button>
                {mode !== "view" && (
                  <Button
                    className="btn btn-primary"
                    type="primary"
                    htmlType="submit"
                  >
                    {mode === "edit" ? "Update" : "Submit"}
                  </Button>
                )}
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default AppFormModal;
